import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";

export default function About() {
  const { t, lang } = useLang();
  const stats = [
    { v: t("about.stat1_v"), l: t("about.stat1_l") },
    { v: t("about.stat2_v"), l: t("about.stat2_l") },
    { v: t("about.stat3_v"), l: t("about.stat3_l") },
    { v: t("about.stat4_v"), l: t("about.stat4_l") },
  ];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="gold-divider" />
              <span className="label-gold">{t("about.label")}</span>
            </div>
            <h2 lang={lang} className="font-display text-[26px] sm:text-3xl lg:text-4xl xl:text-5xl font-semibold text-white leading-[1.15] tracking-tight [text-wrap:balance] [hyphens:auto]">
              {t("about.title")}
            </h2>
          </div>
          <div className="lg:col-span-7 space-y-5 text-neutral-300 leading-relaxed text-base lg:text-lg">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px mt-20 bg-white/10">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.1 }}
              data-testid={`about-stat-${i}`}
              className="bg-[#0A0A0A] p-8 lg:p-10"
            >
              <div className="font-display text-4xl lg:text-5xl font-bold text-[#F2B705] mb-3 tracking-tight">
                {s.v}
              </div>
              <div className="text-xs lg:text-sm text-neutral-400 leading-relaxed">
                {s.l}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
